<template>
  <Grid gtc="1.5fr 1fr" gap="var(--r-space-md) var(--r-space-sp)">
    <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
      <TodoList
        :component="{ type: 'to-do-list' }"
        :context-url="`/subscription/${id}`"
        title="Tasks"
        from-page="subscription"
        @uncompleted-count="updateUncompletedTodos"
      />

      <Notes :entity="{ name: 'subscription', id }" :fill-vertical-space="true" store-namespace="subscriptions" />
    </Grid>

    <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
      <Attachments :entity="{ name: 'subscription', id }" store-namespace="subscriptions" />

      <Links
        ref="links"
        :dropdown-initial-value="linksCategories"
        :entity="{ name: 'subscription', id }"
        store-namespace="subscriptions"
      />
    </Grid>
  </Grid>
</template>

<script>
import { linksCategories } from '@/reusable/data/links-categories'
import TodoModalModule from '@/reusable/TodoModal/vuex/TodoModal'
import { cloneDeep } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
// Components
import Notes from '@components/lm-blocks/Notes'
import Links from '@components/lm-blocks/Links'
import Attachments from '@components/lm-blocks/Attachments'
import TodoList from '@/components/general/ToDoList/ToDoList'

export default {
  components: {
    Notes,
    Links,
    Attachments,
    TodoList
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    alreadyVisitedOnce: false
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscription']),
    linksCategories
  },

  watch: {
    subscription: {
      handler(val) {
        val && this.setEntityForTodo(val)
      },
      immediate: true
    }
  },

  activated() {
    if (this.alreadyVisitedOnce) this.$refs.links.getLinks()
    else this.alreadyVisitedOnce = true
  },

  beforeCreate() {
    this.$store.registerModule('todo-modal', TodoModalModule)
  },

  beforeDestroy() {
    this.resetCreateData()
    this.$store.unregisterModule('todo-modal')
  },

  methods: {
    ...mapMutations('subscription-show', ['setSubscription']),
    ...mapMutations('todo-modal', ['resetCreateData', 'setEntityForTodo']),

    updateUncompletedTodos(count) {
      let subscription = cloneDeep(this.subscription)
      subscription.incomplete_to_dos_count = count
      this.setSubscription(subscription)
    }
  }
}
</script>
